var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-completed-report-card common-card" }, [
    _vm.isLoading === 1
      ? _c("div", { staticClass: "spinner-loading" }, [_c("Spinner")], 1)
      : _c("div", [
          _c("div", { staticClass: "top-card" }, [
            _c("div", { staticClass: "event-name body-text" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.eventInfo.eventName) + "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "expected-screened" }, [
              _c("div", { staticClass: "expected" }, [
                _c("div", { staticClass: "text value-text" }, [
                  _vm._v("Expected")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "value h1-text" }, [
                  _vm._v(_vm._s(_vm.reportData.expectedValue))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "screened" }, [
                _c("div", { staticClass: "text value-text" }, [
                  _vm._v("Screened")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "value h1-text" }, [
                  _vm._v(_vm._s(_vm.reportData.screened))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bottom-card" }, [
            _c("div", { staticClass: "projected-scheduled" }, [
              _c("div", { staticClass: "projected" }, [
                _c("div", { staticClass: "text value-text" }, [
                  _vm._v("Projected Accuracy")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "value h4-text" }, [
                  _vm._v(
                    _vm._s(parseFloat(_vm.reportData.filled).toFixed(0) + "%")
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "screened" }, [
                _c("div", { staticClass: "text value-text" }, [
                  _vm._v("Scheduled")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "value h4-text" }, [
                  _vm._v(_vm._s(_vm.reportData.scheduled))
                ])
              ])
            ])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-660535c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-660535c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/EventCompletedReportCard.vue
// module id = 2014
// module chunks = 1